export function requireAnnotatorAssignment(value, label = "assigned_annotators") {
  if (
    !value ||
    Array.isArray(value) ||
    !Array.isArray(value.parent) ||
    !Array.isArray(value.current)
  ) {
    throw new TypeError(`${label} must contain parent and current arrays`);
  }
  const keys = Object.keys(value).sort();
  if (keys.length !== 2 || keys[0] !== "current" || keys[1] !== "parent") {
    throw new TypeError(`${label} must contain only parent and current arrays`);
  }
  return value;
}

export function normalizeAnnotatorAssignment(value, label = "assigned_annotators") {
  if (value == null) {
    return { parent: [], current: [] };
  }
  if (Array.isArray(value)) {
    return { parent: [], current: value };
  }
  return requireAnnotatorAssignment(value, label);
}

export function normalizeUserAnnotatorAssignments(user) {
  return {
    ...user,
    assigned_sheets: (user.assigned_sheets || []).map((sheet) => ({
      ...sheet,
      sheet_data: {
        ...sheet.sheet_data,
        assigned_annotators: normalizeAnnotatorAssignment(
          sheet.sheet_data?.assigned_annotators,
          `assigned_annotators for ${sheet.sheet_id}`
        ),
      },
    })),
  };
}

export function addDirectAnnotator(value, user) {
  const assignment = requireAnnotatorAssignment(value);
  return {
    parent: assignment.parent,
    current: [...assignment.current, user],
  };
}

export function removeDirectAnnotator(value, userEmail) {
  const assignment = requireAnnotatorAssignment(value);
  return {
    parent: assignment.parent,
    current: assignment.current.filter((annotator) => annotator.email !== userEmail),
  };
}
